import React from 'react';
import { CheckIcon } from '@newcore/icons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Text } from '@newcore/ui/typography';
import { FACTOR_DEFINITIONS } from '@/features/onboarding/constants/onboarding.constants';
import type { FactorType } from '@/features/onboarding/types/onboarding.types';

interface EnrolledFactorsListProps {
  factors: FactorType[];
}

/**
 * Displays list of enrolled authenticators
 * Used in CompleteStep success state
 */
export const EnrolledFactorsList: React.FC<EnrolledFactorsListProps> = ({
  factors,
}) => {
  if (factors.length === 0) {
    return null;
  }

  return (
    <div className='w-full max-w-sm bg-secondary/50 rounded-lg p-4'>
      <Text
        as='p'
        weight={FontWeights.MEDIUM}
        className='text-primary text-left mb-3'
      >
        Your configured authenticators:
      </Text>
      <div className='space-y-2'>
        {factors
          .map(factorType => {
            const config = FACTOR_DEFINITIONS[factorType];

            if (!config) {
              console.warn(`Missing factor definition for: ${factorType}`);

              return null;
            }

            return (
              <div
                key={factorType}
                className='flex items-center gap-3 text-left'
              >
                <CheckIcon className='h-4 w-4 text-utility-green-500 shrink-0' />
                <config.icon className='h-4 w-4 text-tertiary shrink-0' />
                <Text className='text-primary'>{config.displayName}</Text>
              </div>
            );
          })
          .filter(Boolean)}
      </div>
    </div>
  );
};
